import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UploadFileDialogComponent } from '../../dialogs/upload-file-dialog/upload-file-dialog.component';
import { DocumentConstants } from 'app/constants/document.constants';
import { FormService } from 'app/services/form.service';
import { AttachmentModel } from 'app/models/attachment.model';

@Component({
  selector: 'app-nucleic-acid-salts',
  templateUrl: './nucleic-acid-salts.component.html',
  styleUrls: ['./nucleic-acid-salts.component.scss']
})
export class NucleicAcidSaltsComponent {
  readonly dialog = inject(MatDialog);

  constructor(protected formService: FormService) {}

  public openDialog(): void {
    const dialogRef = this.dialog.open(UploadFileDialogComponent, {
          data: { fileName: DocumentConstants.NUCLEIC_ACID_SALTS }
        });
    dialogRef.afterClosed().subscribe();
  }

  get hasNucleicAcidSaltsFile(): boolean {
    return this.formService.doesCurrentFormHaveAttachmentForSection(DocumentConstants.NUCLEIC_ACID_SALTS);
  }

  get attachments(): AttachmentModel[] {
    return this.formService.allAttachmentsForSection(DocumentConstants.NUCLEIC_ACID_SALTS);
  }
}
